import { getVideosByTags } from '../general/js/api/endeavor/services/vod-by-tags-service';

const ENDEAVOR_RECEIVE = 'ENDEAVOR_RECEIVE';

const reducer = (state = {}, action) => {
    switch (action.type) {
        case ENDEAVOR_RECEIVE:
            if (action.payload.contentItems.length) {
                return {
                    ...state,
                    [action.callbackUrl]: action.payload,
                };
            }
            return state;

        default:
            return state;
    }
};

export default reducer;

export const receiveFeed = (callbackUrl, data) => ({
    type: ENDEAVOR_RECEIVE,
    callbackUrl,
    payload: data
});

export const fetchEndeavorFeed = (callbackUrl) => (dispatch) => {
    getVideosByTags({ callbackUrl })
        .then((data) => {
            dispatch(receiveFeed(callbackUrl, data));
        });
};
